import { FC } from "react";
import { CurrentAssessmentResults } from "../../modules/assessment-results/components/current-assessment-results/current-assessment-results";

export const ResultsRoute: FC = () => {
    return (
        <CurrentAssessmentResults />
    )
}